<template>
  <div
    class="flex flex-col py-4 bg-white mb-4"
    :style="{
      borderRadius: '4px',
      border: notFilled ? '1.8px solid red' : '',
    }"
  >
    <vs-col
      vs-w="12"
      vs-type="flex"
      vs-align="center"
      vs-justify="space-between"
    >
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="BookIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Formação</h4>
      </div>

      <vs-button
        class="mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      >
        Editar
      </vs-button>

      <vs-button
        class="sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      />
    </vs-col>

    <hr class="my-4 line" />

    <ul v-if="show()" class="activity-timeline">
      <li v-for="(formation, index) in formations" :key="`step-${index}`">
        <div
          class="timeline-icon"
          :style="{ backgroundColor: color }"
          :key="`timeline-${index}`"
        >
          <feather-icon
            icon="BookIcon"
            svgClasses="text-white stroke-current w-5 h-5"
          ></feather-icon>
        </div>
        <div
          class="formation-detail--date"
          v-if="
            formation.from_date != null ||
            (formation.from_date != undefined && formation.to_date != null) ||
            (formation_to_date != undefined && formation.period != null) ||
            formation.period != undefined
          "
        >
          {{
            (formation.from_date) ? 
              formation.from_date
                .concat(` até ${formation.to_date}`)
                .concat(` (${formation.period})`)
              :
              (
                ((formation.from_date === null || formation.from_date === undefined) && formation.to_date) 
                  ? 'Início Não Informado - ' + formation.to_date
                  : formation.from_date + '- Não Informado' )
          }}
        </div>
        <div
          class="formation-detail--institute"
          v-if="
            formation.grade != null ||
            (formation.grade != undefined && formation.institute != null) ||
            formation.institute != undefined
          "
        >
          {{ formation.grade.concat(` - ${formation.institute}`) }}
        </div>
        <div
          class="formation-detail--level"
          v-if="
            formation.scholarity != null ||
            (formation.scholarity != undefined && formation.level != null) ||
            formation.level != undefined
          "
        >
          {{ formation.scholarity.concat(` - ${formation.level}`) }}
        </div>
        <!-- <div class="formation-detail--action">
                    <a href="#">Visualizar certificado</a>
                </div> -->
      </li>
    </ul>
    <EmptyDetailCard
      v-else
      description="Você ainda não preencheu nenhuma informação de formação..."
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import { formatDistanceStrict } from 'date-fns'
// import ptBR from 'date-fns/locale/pt-BR'
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  name: "simple-formation",
  props: {
    notFilled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("formation", ["formations"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    ...mapActions("step", ["updateCurrentStep"]),
    // periodComputed({ from_date, to_date }) {
    //     const splitFrom = '01/'.concat(from_date).split('/')
    //     const splitTo = '01/'.concat(to_date).split('/')

    //     const from = new Date(splitFrom[2], splitFrom[1] -1, splitFrom[0])
    //     const to = new Date(splitTo[2], splitTo[1] -1, splitTo[0])

    //     return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true })
    // },
    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 4 });
      this.$router.push({ name: "step-formation" });
    },

    show() {
      return this.formations.length > 0;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";
</style>
